import { useUnitSystem } from '../contexts';

export function useUnits() {
  const [unitData] = useUnitSystem();

  return unitData;
}
